module.exports = __webpack_public_path__ + "static/servico2-7322268ce81ef0328b95caed3b63d2d2.jpg";